var map = {
	"./background.png": "30b3",
	"./bed.png": "2c5b",
	"./cafe-1.png": "81b6",
	"./cafe-2.png": "24ad",
	"./dirty-couch.png": "6ca3",
	"./empty-fridge.png": "f19d",
	"./exercise.png": "56fa",
	"./food.png": "5f0a",
	"./house-lg-left.png": "23bb",
	"./house-lg-right.png": "0a43",
	"./house-sm-left.png": "7e06",
	"./house-sm-right.png": "e4c0",
	"./pandemic-title.png": "dea6",
	"./park-1.png": "5dc3",
	"./rest-1.png": "f5c9",
	"./rest-2.png": "c8c6",
	"./virus.png": "1f72"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e01";